<div class="dashboard-history" *ngIf="dashboardData">
  <!-- Header del Dashboard -->
  <div class="dashboard-header">
    <div class="vehicle-info">
      <h3>{{ dashboardData.vehicleInfo.unitName }}</h3>
      <p class="imei">IMEI: {{ dashboardData.vehicleInfo.imei }}</p>
      <p class="date-range">
        {{ dashboardData.vehicleInfo.startDate | date : "dd/MM/yyyy HH:mm" }} -
        {{ dashboardData.vehicleInfo.endDate | date : "dd/MM/yyyy HH:mm" }}
      </p>
      <p class="duration">
        Duración: {{ dashboardData.vehicleInfo.totalDuration }}
      </p>
    </div>

    <!-- Controles de visualización -->
    <div class="dashboard-controls">
      <button
        class="control-btn"
        [class.active]="showStatistics"
        (click)="toggleStatistics()"
        title="Mostrar/Ocultar Estadísticas"
      >
        <!-- <svg width="16" height="16" fill="currentColor">
          <use xlink:href="./assets/icons/sprite.svg#list"></use>
        </svg> -->
        <mat-icon size="18">list_alt</mat-icon>
      </button>
      <button
        class="control-btn"
        [class.active]="showSpeedChart"
        (click)="toggleSpeedChart()"
        title="Mostrar/Ocultar Gráfico de Velocidad"
      >
        <!-- <svg width="16" height="16" fill="currentColor">
          <use xlink:href="./assets/icons/sprite.svg#trending-up"></use>
        </svg> -->
        <mat-icon size="18">trending_up</mat-icon>
      </button>
      <button
        class="control-btn"
        [class.active]="showAltitudeChart"
        (click)="toggleAltitudeChart()"
        title="Mostrar/Ocultar Gráfico de Altitud"
      >
        <!-- <svg width="16" height="16" fill="currentColor">
          <use xlink:href="./assets/icons/sprite.svg#mountain"></use>
        </svg> -->
        <mat-icon size="18">terrain</mat-icon>
      </button>
      <button
        class="control-btn"
        [class.active]="showSpeedDistribution"
        (click)="toggleSpeedDistribution()"
        title="Mostrar/Ocultar Distribución de Velocidades"
      >
        <!-- <svg width="16" height="16" fill="currentColor">
          <use xlink:href="./assets/icons/sprite.svg#pie-chart"></use>
        </svg> -->
        <mat-icon size="18">donut_large</mat-icon>
      </button>
      <button
        *appHasPermission="'history_temperature_BLE_chart'"
        class="control-btn"
        [class.active]="showTemperatureBleCharts"
        (click)="toggleTemperatureBleChart()"
        title="Mostrar/Ocultar Gráficos de Temperatura BLE"
      >
        <!-- <svg width="16" height="16" fill="currentColor">
          <use xlink:href="./assets/icons/sprite.svg#thermometer-cold"></use>
        </svg> -->
        <mat-icon size="18">thermostat</mat-icon>
      </button>
      <button
        *appHasPermission="'history_temperature_EYE_chart'"
        class="control-btn"
        [class.active]="showTemperatureEyeCharts"
        (click)="toggleTemperatureEyeChart()"
        title="Mostrar/Ocultar Gráficos de Temperatura EYE"
      >
        <!-- <svg width="16" height="16" fill="currentColor">
          <use xlink:href="./assets/icons/sprite.svg#thermometer-hot"></use>
        </svg> -->
        <mat-icon size="18">device_thermostat</mat-icon>
      </button>
      <button
        *appHasPermission="'history_humidity_BLE_chart'"
        class="control-btn"
        [class.active]="showHumidityBleCharts"
        (click)="toggleHumidityBleChart()"
        title="Mostrar/Ocultar Gráficos de Humedad BLE"
      >
        <mat-icon size="18">opacity</mat-icon>
      </button>
      <button
        *appHasPermission="'history_humidity_EYE_chart'"
        class="control-btn"
        [class.active]="showHumidityEyeCharts"
        (click)="toggleHumidityEyeChart()"
        title="Mostrar/Ocultar Gráficos de Humedad EYE"
      >
        <mat-icon size="18">water_drop</mat-icon>
      </button>

      <!-- Separador -->
      <div class="controls-separator"></div>

      <!-- Botones de Exportación -->
      <button
        *appHasPermission="'history_export_dashboard_pdf'"
        class="control-btn export-btn"
        (click)="generateCompletePDF()"
        [disabled]="isGeneratingPDF"
        title="Exportar Dashboard completo a PDF"
      >
        <mat-icon size="18" *ngIf="!isGeneratingPDF">picture_as_pdf</mat-icon>
        <mat-icon size="18" *ngIf="isGeneratingPDF" class="spinning">hourglass_empty</mat-icon>
      </button>

      <!-- <button
        class="control-btn export-btn"
        (click)="exportInNewWindow()"
        title="Abrir en ventana nueva para imprimir"
      >
        <mat-icon size="18">open_in_new</mat-icon>
      </button> -->
    </div>
  </div>

  <!-- Contenido del Dashboard -->
  <div class="dashboard-content">
    <!-- Estadísticas Generales -->
    <div class="statistics-section" *ngIf="showStatistics">
      <h4>Estadísticas Generales</h4>
      <div class="stats-grid">
        <div class="stat-card">
          <div class="stat-icon">
            <!-- <svg width="20" height="20" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#map"></use>
            </svg> -->
            <mat-icon size="20">directions</mat-icon>
          </div>
          <div class="stat-content">
            <span class="stat-label">Distancia Total</span>
            <span class="stat-value">{{
              formatDistance(dashboardData.statistics.totalDistance)
            }}</span>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-icon">
            <!-- <svg width="20" height="20" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#zap"></use>
            </svg> -->
            <mat-icon size="20">flash_on</mat-icon>
          </div>
          <div class="stat-content">
            <span class="stat-label">Velocidad Máxima</span>
            <span class="stat-value">{{
              formatSpeed(dashboardData.statistics.maxSpeed)
            }}</span>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-icon">
            <!-- <svg width="20" height="20" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#activity"></use>
            </svg> -->
            <mat-icon size="20">access_time</mat-icon>
          </div>
          <div class="stat-content">
            <span class="stat-label">Velocidad Promedio</span>
            <span class="stat-value">{{
              formatSpeed(dashboardData.statistics.avgSpeed)
            }}</span>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-icon">
            <!-- <svg width="20" height="20" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#mountain"></use>
            </svg> -->
            <mat-icon size="20">landscape</mat-icon>
          </div>
          <div class="stat-content">
            <span class="stat-label">Altitud Máxima</span>
            <span class="stat-value">{{
              formatAltitude(dashboardData.statistics.maxAltitude)
            }}</span>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-icon">
            <!-- <svg width="20" height="20" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#clock"></use>
            </svg> -->
            <mat-icon size="20">directions_run</mat-icon>
          </div>
          <div class="stat-content">
            <span class="stat-label">Tiempo en Movimiento</span>
            <span class="stat-value">{{
              formatDuration(dashboardData.statistics.movementTime)
            }}</span>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-icon">
            <!-- <svg width="20" height="20" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#stop"></use>
            </svg> -->
            <mat-icon size="20">front_hand</mat-icon>
          </div>
          <div class="stat-content">
            <span class="stat-label">Tiempo Detenido</span>
            <span class="stat-value">{{
              formatDuration(dashboardData.statistics.stoppedTime)
            }}</span>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-icon">
            <!-- <svg width="20" height="20" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#map-pin"></use>
            </svg> -->
            <mat-icon size="20">place</mat-icon>
          </div>
          <div class="stat-content">
            <span class="stat-label">Total de Paradas</span>
            <span class="stat-value">{{
              dashboardData.statistics.totalStops
            }}</span>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-icon">
            <!-- <svg width="20" height="20" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#alert"></use>
            </svg> -->
            <mat-icon size="20">car_crash</mat-icon>
          </div>
          <div class="stat-content">
            <span class="stat-label">Total de Eventos</span>
            <span class="stat-value">{{
              dashboardData.statistics.totalEvents
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Gráficos -->
    <div class="charts-section">
      <!-- Gráfico de Velocidad -->
      <div class="chart-container modern-chart-card" *ngIf="showSpeedChart">
        <div class="chart-header">
          <div class="chart-title-wrapper">
            <i class="pi pi-chart-line chart-icon"></i>
            <h4>Velocidad vs Tiempo</h4>
          </div>
          <div class="chart-info">
            <span class="info-badge speed">Tiempo Real</span>
          </div>
        </div>
        <div class="chart-wrapper">
          <canvas #speedChart></canvas>
        </div>
      </div>

      <!-- Gráfico de Altitud -->
      <div class="chart-container modern-chart-card" *ngIf="showAltitudeChart">
        <div class="chart-header">
          <div class="chart-title-wrapper">
            <i class="pi pi-chart-line chart-icon"></i>
            <h4>Altitud vs Tiempo</h4>
          </div>
          <div class="chart-info">
            <span class="info-badge elevation">Elevación</span>
          </div>
        </div>
        <div class="chart-wrapper">
          <canvas #altitudeChart></canvas>
        </div>
      </div>

      <!-- Distribución de Velocidades -->
      <div
        class="chart-container modern-chart-card distribution-chart"
        *ngIf="showSpeedDistribution"
      >
        <div class="chart-header">
          <div class="chart-title-wrapper">
            <i class="pi pi-chart-bar chart-icon"></i>
            <h4>Distribución de Velocidades</h4>
          </div>
          <div class="chart-info">
            <span class="info-badge distribution">Análisis</span>
          </div>
        </div>
        <div class="chart-wrapper">
          <canvas #speedDistributionChart></canvas>
        </div>
        <div class="distribution-legend modern-legend">
          <div
            class="legend-item"
            *ngFor="let item of dashboardData.speedDistribution; let i = index"
          >
            <div
              class="legend-color"
              [ngStyle]="getSpeedRangeColor(item.speedRange)"
            ></div>
            <span class="legend-label">{{ item.speedRange }}</span>
            <span class="legend-value"
              >{{ item.percentage }}% ({{ item.count }})</span
            >
          </div>
        </div>
      </div>

      <!-- Gráficos de Temperatura BLE Individuales -->
      <ng-container *appHasPermission="'history_temperature_BLE_chart'">
        <div *ngIf="showTemperatureBleCharts">
          <!-- Gráfico BLE #1 -->
          <div
            class="chart-container modern-chart-card"
            *ngIf="temperatureBle1Data.length > 0"
          >
            <div class="chart-header">
              <div class="chart-title-wrapper">
                <i class="pi pi-chart-line chart-icon"></i>
                <h4>Temperatura BLE #1 vs Tiempo</h4>
              </div>
              <div class="chart-info">
                <span class="info-badge temperature">BLE #1</span>
                <div class="config-selector">
                  <label for="tempConfigBle1">Límites:</label>
                  <select
                    id="tempConfigBle1"
                    class="config-select"
                    [value]="getCurrentTempConfigIndex('ble1')"
                    (change)="onTemperatureConfigChange('ble1', $event.target.value)"
                  >
                    <option value="0" *ngIf="temperatureConfigurations.length === 0">Por defecto</option>
                    <option
                      *ngFor="let config of temperatureConfigurations; let i = index"
                      [value]="i"
                    >
                      {{config.nombre}} ({{config.temperature_min}}° , {{config.temperature_max}}°)
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="chart-wrapper">
              <canvas #temperatureBle1ChartRef></canvas>
            </div>
          </div>

          <!-- Gráfico BLE #2 -->
          <div
            class="chart-container modern-chart-card"
            *ngIf="temperatureBle2Data.length > 0"
          >
            <div class="chart-header">
              <div class="chart-title-wrapper">
                <i class="pi pi-chart-line chart-icon"></i>
                <h4>Temperatura BLE #2 vs Tiempo</h4>
              </div>
              <div class="chart-info">
                <span class="info-badge temperature">BLE #2</span>
                <div class="config-selector">
                  <label for="tempConfigBle2">Límites:</label>
                  <select
                    id="tempConfigBle2"
                    class="config-select"
                    [value]="getCurrentTempConfigIndex('ble2')"
                    (change)="onTemperatureConfigChange('ble2', $event.target.value)"
                  >
                    <option value="0" *ngIf="temperatureConfigurations.length === 0">Por defecto</option>
                    <option
                      *ngFor="let config of temperatureConfigurations; let i = index"
                      [value]="i"
                    >
                      {{config.nombre}} ({{config.temperature_min}}° , {{config.temperature_max}}°)
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="chart-wrapper">
              <canvas #temperatureBle2ChartRef></canvas>
            </div>
          </div>

          <!-- Gráfico BLE #3 -->
          <div
            class="chart-container modern-chart-card"
            *ngIf="temperatureBle3Data.length > 0"
          >
            <div class="chart-header">
              <div class="chart-title-wrapper">
                <i class="pi pi-chart-line chart-icon"></i>
                <h4>Temperatura BLE #3 vs Tiempo</h4>
              </div>
              <div class="chart-info">
                <span class="info-badge temperature">BLE #3</span>
                <div class="config-selector">
                  <label for="tempConfigBle3">Límites:</label>
                  <select
                    id="tempConfigBle3"
                    class="config-select"
                    [value]="getCurrentTempConfigIndex('ble3')"
                    (change)="onTemperatureConfigChange('ble3', $event.target.value)"
                  >
                    <option value="0" *ngIf="temperatureConfigurations.length === 0">Por defecto</option>
                    <option
                      *ngFor="let config of temperatureConfigurations; let i = index"
                      [value]="i"
                    >
                      {{config.nombre}} ({{config.temperature_min}}° , {{config.temperature_max}}°)
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="chart-wrapper">
              <canvas #temperatureBle3ChartRef></canvas>
            </div>
          </div>

          <!-- Gráfico BLE #4 -->
          <div
            class="chart-container modern-chart-card"
            *ngIf="temperatureBle4Data.length > 0"
          >
            <div class="chart-header">
              <div class="chart-title-wrapper">
                <i class="pi pi-chart-line chart-icon"></i>
                <h4>Temperatura BLE #4 vs Tiempo</h4>
              </div>
              <div class="chart-info">
                <span class="info-badge temperature">BLE #4</span>
                <div class="config-selector">
                  <label for="tempConfigBle4">Límites:</label>
                  <select
                    id="tempConfigBle4"
                    class="config-select"
                    [value]="getCurrentTempConfigIndex('ble4')"
                    (change)="onTemperatureConfigChange('ble4', $event.target.value)"
                  >
                    <option value="0" *ngIf="temperatureConfigurations.length === 0">Por defecto</option>
                    <option
                      *ngFor="let config of temperatureConfigurations; let i = index"
                      [value]="i"
                    >
                      {{config.nombre}} ({{config.temperature_min}}° , {{config.temperature_max}}°)
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="chart-wrapper">
              <canvas #temperatureBle4ChartRef></canvas>
            </div>
          </div>

          <!-- Mensaje cuando no hay datos BLE -->
          <div
            class="chart-container modern-chart-card no-data-chart"
            *ngIf="!hasTemperatureBleData()"
          >
            <div class="no-data-content">
              <mat-icon size="48">thermostat</mat-icon>
              <h3>No hay datos de temperatura BLE</h3>
              <p>No se encontraron datos de sensores BLE en el período seleccionado</p>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Gráficos de Temperatura EYE Individuales -->
      <ng-container *appHasPermission="'history_temperature_EYE_chart'">
        <div *ngIf="showTemperatureEyeCharts">
          <!-- Gráfico EYE #1 -->
          <div
            class="chart-container modern-chart-card"
            *ngIf="temperatureEye1Data.length > 0"
          >
            <div class="chart-header">
              <div class="chart-title-wrapper">
                <i class="pi pi-chart-line chart-icon"></i>
                <h4>Temperatura EYE #1 vs Tiempo</h4>
              </div>
              <div class="chart-info">
                <span class="info-badge temperature">EYE #1</span>
                <div class="config-selector">
                  <label for="tempConfigEye1">Límites:</label>
                  <select
                    id="tempConfigEye1"
                    class="config-select"
                    [value]="getCurrentTempConfigIndex('eye1')"
                    (change)="onTemperatureConfigChange('eye1', $event.target.value)"
                  >
                    <option value="0" *ngIf="temperatureConfigurations.length === 0">Por defecto</option>
                    <option
                      *ngFor="let config of temperatureConfigurations; let i = index"
                      [value]="i"
                    >
                      {{config.nombre}} ({{config.temperature_min}}° , {{config.temperature_max}}°)
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="chart-wrapper">
              <canvas #temperatureEye1ChartRef></canvas>
            </div>
          </div>

          <!-- Gráfico EYE #2 -->
          <div
            class="chart-container modern-chart-card"
            *ngIf="temperatureEye2Data.length > 0"
          >
            <div class="chart-header">
              <div class="chart-title-wrapper">
                <i class="pi pi-chart-line chart-icon"></i>
                <h4>Temperatura EYE #2 vs Tiempo</h4>
              </div>
              <div class="chart-info">
                <span class="info-badge temperature">EYE #2</span>
                <div class="config-selector">
                  <label for="tempConfigEye2">Límites:</label>
                  <select
                    id="tempConfigEye2"
                    class="config-select"
                    [value]="getCurrentTempConfigIndex('eye2')"
                    (change)="onTemperatureConfigChange('eye2', $event.target.value)"
                  >
                    <option value="0" *ngIf="temperatureConfigurations.length === 0">Por defecto</option>
                    <option
                      *ngFor="let config of temperatureConfigurations; let i = index"
                      [value]="i"
                    >
                      {{config.nombre}} ({{config.temperature_min}}° , {{config.temperature_max}}°)
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="chart-wrapper">
              <canvas #temperatureEye2ChartRef></canvas>
            </div>
          </div>

          <!-- Gráfico EYE #3 -->
          <div
            class="chart-container modern-chart-card"
            *ngIf="temperatureEye3Data.length > 0"
          >
            <div class="chart-header">
              <div class="chart-title-wrapper">
                <i class="pi pi-chart-line chart-icon"></i>
                <h4>Temperatura EYE #3 vs Tiempo</h4>
              </div>
              <div class="chart-info">
                <span class="info-badge temperature">EYE #3</span>
                <div class="config-selector">
                  <label for="tempConfigEye3">Límites:</label>
                  <select
                    id="tempConfigEye3"
                    class="config-select"
                    [value]="getCurrentTempConfigIndex('eye3')"
                    (change)="onTemperatureConfigChange('eye3', $event.target.value)"
                  >
                    <option value="0" *ngIf="temperatureConfigurations.length === 0">Por defecto</option>
                    <option
                      *ngFor="let config of temperatureConfigurations; let i = index"
                      [value]="i"
                    >
                      {{config.nombre}} ({{config.temperature_min}}° , {{config.temperature_max}}°)
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="chart-wrapper">
              <canvas #temperatureEye3ChartRef></canvas>
            </div>
          </div>

          <!-- Gráfico EYE #4 -->
          <div
            class="chart-container modern-chart-card"
            *ngIf="temperatureEye4Data.length > 0"
          >
            <div class="chart-header">
              <div class="chart-title-wrapper">
                <i class="pi pi-chart-line chart-icon"></i>
                <h4>Temperatura EYE #4 vs Tiempo</h4>
              </div>
              <div class="chart-info">
                <span class="info-badge temperature">EYE #4</span>
                <div class="config-selector">
                  <label for="tempConfigEye4">Límites:</label>
                  <select
                    id="tempConfigEye4"
                    class="config-select"
                    [value]="getCurrentTempConfigIndex('eye4')"
                    (change)="onTemperatureConfigChange('eye4', $event.target.value)"
                  >
                    <option value="0" *ngIf="temperatureConfigurations.length === 0">Por defecto</option>
                    <option
                      *ngFor="let config of temperatureConfigurations; let i = index"
                      [value]="i"
                    >
                      {{config.nombre}} ({{config.temperature_min}}° , {{config.temperature_max}}°)
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="chart-wrapper">
              <canvas #temperatureEye4ChartRef></canvas>
            </div>
          </div>

          <!-- Mensaje cuando no hay datos EYE -->
          <div
            class="chart-container modern-chart-card no-data-chart"
            *ngIf="!hasTemperatureEyeData()"
          >
            <div class="no-data-content">
              <mat-icon size="48">device_thermostat</mat-icon>
              <h3>No hay datos de temperatura EYE</h3>
              <p>No se encontraron datos de sensores EYE en el período seleccionado</p>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Gráficos de Humedad BLE Individuales -->
      <ng-container *appHasPermission="'history_humidity_BLE_chart'">
        <div *ngIf="showHumidityBleCharts">
          <!-- Gráfico BLE Humedad #1 -->
          <div
            class="chart-container modern-chart-card"
            *ngIf="humidityBle1Data.length > 0"
          >
            <div class="chart-header">
              <div class="chart-title-wrapper">
                <i class="pi pi-chart-line chart-icon"></i>
                <h4>Humedad BLE #1 vs Tiempo</h4>
              </div>
              <div class="chart-info">
                <span class="info-badge humidity">BLE #1</span>
                <div class="config-selector">
                  <label for="humConfigBle1">Límites:</label>
                  <select
                    id="humConfigBle1"
                    class="config-select"
                    [value]="getCurrentHumConfigIndex('ble1')"
                    (change)="onHumidityConfigChange('ble1', $event.target.value)"
                  >
                    <option value="0" *ngIf="humidityConfigurations.length === 0">Por defecto</option>
                    <option
                      *ngFor="let config of humidityConfigurations; let i = index"
                      [value]="i"
                    >
                      {{config.nombre}} ({{config.humidity_min}}% , {{config.humidity_max}}%)
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="chart-wrapper">
              <canvas #humidityBle1ChartRef></canvas>
            </div>
          </div>

          <!-- Gráfico BLE Humedad #2 -->
          <div
            class="chart-container modern-chart-card"
            *ngIf="humidityBle2Data.length > 0"
          >
            <div class="chart-header">
              <div class="chart-title-wrapper">
                <i class="pi pi-chart-line chart-icon"></i>
                <h4>Humedad BLE #2 vs Tiempo</h4>
              </div>
              <div class="chart-info">
                <span class="info-badge humidity">BLE #2</span>
                <div class="config-selector">
                  <label for="humConfigBle2">Límites:</label>
                  <select
                    id="humConfigBle2"
                    class="config-select"
                    [value]="getCurrentHumConfigIndex('ble2')"
                    (change)="onHumidityConfigChange('ble2', $event.target.value)"
                  >
                    <option value="0" *ngIf="humidityConfigurations.length === 0">Por defecto</option>
                    <option
                      *ngFor="let config of humidityConfigurations; let i = index"
                      [value]="i"
                    >
                      {{config.nombre}} ({{config.humidity_min}}% , {{config.humidity_max}}%)
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="chart-wrapper">
              <canvas #humidityBle2ChartRef></canvas>
            </div>
          </div>

          <!-- Gráfico BLE Humedad #3 -->
          <div
            class="chart-container modern-chart-card"
            *ngIf="humidityBle3Data.length > 0"
          >
            <div class="chart-header">
              <div class="chart-title-wrapper">
                <i class="pi pi-chart-line chart-icon"></i>
                <h4>Humedad BLE #3 vs Tiempo</h4>
              </div>
              <div class="chart-info">
                <span class="info-badge humidity">BLE #3</span>
                <div class="config-selector">
                  <label for="humConfigBle3">Límites:</label>
                  <select
                    id="humConfigBle3"
                    class="config-select"
                    [value]="getCurrentHumConfigIndex('ble3')"
                    (change)="onHumidityConfigChange('ble3', $event.target.value)"
                  >
                    <option value="0" *ngIf="humidityConfigurations.length === 0">Por defecto</option>
                    <option
                      *ngFor="let config of humidityConfigurations; let i = index"
                      [value]="i"
                    >
                      {{config.nombre}} ({{config.humidity_min}}% , {{config.humidity_max}}%)
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="chart-wrapper">
              <canvas #humidityBle3ChartRef></canvas>
            </div>
          </div>

          <!-- Gráfico BLE Humedad #4 -->
          <div
            class="chart-container modern-chart-card"
            *ngIf="humidityBle4Data.length > 0"
          >
            <div class="chart-header">
              <div class="chart-title-wrapper">
                <i class="pi pi-chart-line chart-icon"></i>
                <h4>Humedad BLE #4 vs Tiempo</h4>
              </div>
              <div class="chart-info">
                <span class="info-badge humidity">BLE #4</span>
                <div class="config-selector">
                  <label for="humConfigBle4">Límites:</label>
                  <select
                    id="humConfigBle4"
                    class="config-select"
                    [value]="getCurrentHumConfigIndex('ble4')"
                    (change)="onHumidityConfigChange('ble4', $event.target.value)"
                  >
                    <option value="0" *ngIf="humidityConfigurations.length === 0">Por defecto</option>
                    <option
                      *ngFor="let config of humidityConfigurations; let i = index"
                      [value]="i"
                    >
                      {{config.nombre}} ({{config.humidity_min}}% , {{config.humidity_max}}%)
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="chart-wrapper">
              <canvas #humidityBle4ChartRef></canvas>
            </div>
          </div>

          <!-- Mensaje cuando no hay datos BLE Humedad -->
          <div
            class="chart-container modern-chart-card no-data-chart"
            *ngIf="!hasHumidityBleData()"
          >
            <div class="no-data-content">
              <mat-icon size="48">opacity</mat-icon>
              <h3>No hay datos de humedad BLE</h3>
              <p>No se encontraron datos de sensores BLE de humedad en el período seleccionado</p>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Gráficos de Humedad EYE Individuales -->
      <ng-container *appHasPermission="'history_humidity_EYE_chart'">
        <div *ngIf="showHumidityEyeCharts">
          <!-- Gráfico EYE Humedad #1 -->
          <div
            class="chart-container modern-chart-card"
            *ngIf="humidityEye1Data.length > 0"
          >
            <div class="chart-header">
              <div class="chart-title-wrapper">
                <i class="pi pi-chart-line chart-icon"></i>
                <h4>Humedad EYE #1 vs Tiempo</h4>
              </div>
              <div class="chart-info">
                <span class="info-badge humidity">EYE #1</span>
                <div class="config-selector">
                  <label for="humConfigEye1">Límites:</label>
                  <select
                    id="humConfigEye1"
                    class="config-select"
                    [value]="getCurrentHumConfigIndex('eye1')"
                    (change)="onHumidityConfigChange('eye1', $event.target.value)"
                  >
                    <option value="0" *ngIf="humidityConfigurations.length === 0">Por defecto</option>
                    <option
                      *ngFor="let config of humidityConfigurations; let i = index"
                      [value]="i"
                    >
                      {{config.nombre}} ({{config.humidity_min}}% , {{config.humidity_max}}%)
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="chart-wrapper">
              <canvas #humidityEye1ChartRef></canvas>
            </div>
          </div>

          <!-- Gráfico EYE Humedad #2 -->
          <div
            class="chart-container modern-chart-card"
            *ngIf="humidityEye2Data.length > 0"
          >
            <div class="chart-header">
              <div class="chart-title-wrapper">
                <i class="pi pi-chart-line chart-icon"></i>
                <h4>Humedad EYE #2 vs Tiempo</h4>
              </div>
              <div class="chart-info">
                <span class="info-badge humidity">EYE #2</span>
                <div class="config-selector">
                  <label for="humConfigEye2">Límites:</label>
                  <select
                    id="humConfigEye2"
                    class="config-select"
                    [value]="getCurrentHumConfigIndex('eye2')"
                    (change)="onHumidityConfigChange('eye2', $event.target.value)"
                  >
                    <option value="0" *ngIf="humidityConfigurations.length === 0">Por defecto</option>
                    <option
                      *ngFor="let config of humidityConfigurations; let i = index"
                      [value]="i"
                    >
                      {{config.nombre}} ({{config.humidity_min}}% , {{config.humidity_max}}%)
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="chart-wrapper">
              <canvas #humidityEye2ChartRef></canvas>
            </div>
          </div>

          <!-- Gráfico EYE Humedad #3 -->
          <div
            class="chart-container modern-chart-card"
            *ngIf="humidityEye3Data.length > 0"
          >
            <div class="chart-header">
              <div class="chart-title-wrapper">
                <i class="pi pi-chart-line chart-icon"></i>
                <h4>Humedad EYE #3 vs Tiempo</h4>
              </div>
              <div class="chart-info">
                <span class="info-badge humidity">EYE #3</span>
                <div class="config-selector">
                  <label for="humConfigEye3">Límites:</label>
                  <select
                    id="humConfigEye3"
                    class="config-select"
                    [value]="getCurrentHumConfigIndex('eye3')"
                    (change)="onHumidityConfigChange('eye3', $event.target.value)"
                  >
                    <option value="0" *ngIf="humidityConfigurations.length === 0">Por defecto</option>
                    <option
                      *ngFor="let config of humidityConfigurations; let i = index"
                      [value]="i"
                    >
                      {{config.nombre}} ({{config.humidity_min}}% , {{config.humidity_max}}%)
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="chart-wrapper">
              <canvas #humidityEye3ChartRef></canvas>
            </div>
          </div>

          <!-- Gráfico EYE Humedad #4 -->
          <div
            class="chart-container modern-chart-card"
            *ngIf="humidityEye4Data.length > 0"
          >
            <div class="chart-header">
              <div class="chart-title-wrapper">
                <i class="pi pi-chart-line chart-icon"></i>
                <h4>Humedad EYE #4 vs Tiempo</h4>
              </div>
              <div class="chart-info">
                <span class="info-badge humidity">EYE #4</span>
                <div class="config-selector">
                  <label for="humConfigEye4">Límites:</label>
                  <select
                    id="humConfigEye4"
                    class="config-select"
                    [value]="getCurrentHumConfigIndex('eye4')"
                    (change)="onHumidityConfigChange('eye4', $event.target.value)"
                  >
                    <option value="0" *ngIf="humidityConfigurations.length === 0">Por defecto</option>
                    <option
                      *ngFor="let config of humidityConfigurations; let i = index"
                      [value]="i"
                    >
                      {{config.nombre}} ({{config.humidity_min}}% , {{config.humidity_max}}%)
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="chart-wrapper">
              <canvas #humidityEye4ChartRef></canvas>
            </div>
          </div>

          <!-- Mensaje cuando no hay datos EYE Humedad -->
          <div
            class="chart-container modern-chart-card no-data-chart"
            *ngIf="!hasHumidityEyeData()"
          >
            <div class="no-data-content">
              <mat-icon size="48">water_drop</mat-icon>
              <h3>No hay datos de humedad EYE</h3>
              <p>No se encontraron datos de sensores EYE de humedad en el período seleccionado</p>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- Mensaje cuando no hay datos -->
<div class="no-data" *ngIf="!dashboardData">
  <div class="no-data-content">
    <!-- <svg width="48" height="48" fill="currentColor">
      <use xlink:href="./assets/icons/sprite.svg#chart-bar"></use>
    </svg> -->
    <mat-icon size="48">bar_chart</mat-icon>
    <h3>No hay datos disponibles</h3>
    <p>Selecciona un historial para ver el dashboard</p>
  </div>
</div>
